module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"OUR CATEGORIES","deals":"Sale","subtitle":"- Browse"},"ar":{"title":"فئاتنا","deals":"أفضل العروض","subtitle":"- تصفح"}}')
  delete Component.options._Ctor
}
